// Author Lin
// Date 2021-07-20 17:49:21

import * as model from "@/model/sithMes/inventory/SithMesInventoryStorageInputModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryStorageInput(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'purchaseFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'productsFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'purchaseEntity',
        entityConstructor: model.SithMesInventoryStorageInput
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'productsEntity',
        entityConstructor: model.SithMesInventoryStorageInput
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'purchaseVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'productsVo'
    })
    .buildStore()
